export default __webpack_public_path__ + "static/media/mon_64.df46f2c0.png";